import { AnswerStatus } from '@app/src/types/resourceExplorer'
import type { FormData, ResponseItemAnswer } from '../Provider/ProviderReport'

const isQuestionSkipped = (value: ResponseItemAnswer): boolean =>
  Boolean(value.cannotAnswer) && value.answerStatus !== AnswerStatus.Excluded

export const buildResponseItems = (values: FormData) =>
  Object.entries(values).map(([requestItemId, value]) => {
    const skipped = isQuestionSkipped(value)

    return {
      id: value.id,
      requestItemId,
      answer: skipped ? '' : (value.answer ?? ''),
      selectedOptions: skipped ? [] : [value.selectedOptions ?? []].flat(),
      coordinates: skipped ? undefined : value.coordinates,
      estimatedAnswerAt: value.estimatedAnswerAt,
      cannotAnswer: Boolean(value.cannotAnswer),
      expiresAt: value.expiresAt,
      answerStatus: value.answerStatus,
      comment: value.comment,
    }
  })
